module.exports = __webpack_public_path__ + "img/img10.b5f9dc94.svg";